import React from 'react';
import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import config from 'config';
import Logo from 'components/common/Logo';

const LogoSection = () => (
	<ButtonBase disableRipple component={Link} to={config.defaultPath}>
		<Logo light={true} />
	</ButtonBase>
);

export default LogoSection;
